import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import { EXTERNAL_LINKS } from '../../../app-config';
import BuildOnHatLogo from '../../../assets/buildHat.png';
import { DSButton } from '../../../components/Button/Button';
import usePageStyles from '../styles';

const useStyles = makeStyles((theme) => ({
  buttonRow: {
    zIndex: 5,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
  },
  image: {
    zIndex: 1,
    marginTop: '-12%',

    '& img': {
      width: '100%',
    },
  },
  startedButton: {
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '96px',
    },
  },
  buildOnHat: {
    backgroundColor: theme.palette.background.default,
    paddingTop: '100px',
  },
}));

const BuildOnHat: React.FC = () => {
  const pageClasses = usePageStyles();
  const classes = useStyles();

  return (
    <Grid
      container
      className={`${pageClasses.section} ${classes.buildOnHat}`}
      justifyContent="center"
      alignItems="center"
    >
      <Grid container justifyContent="center">
        <Grid item>
          <Typography className={pageClasses.text} variant="h1">
            Build on the HAT Personal Data Account
          </Typography>
        </Grid>
      </Grid>

      <Grid container justifyContent="center">
        <Grid item>
          <Typography className={pageClasses.text} variant="subtitle2">
            Powered by the Dataswift One Platform
          </Typography>
        </Grid>
      </Grid>

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={3} className={classes.buttonRow}>
          <a href={EXTERNAL_LINKS.dataswiftDocs} target="_blank" rel="noopener noreferrer">
            <DSButton className={classes.startedButton}>Get Started</DSButton>
          </a>
        </Grid>
      </Grid>

      <Grid container justifyContent="center" className={classes.image}>
        <Grid item xs={12} md={8}>
          <img src={BuildOnHatLogo} alt="Build on Hat" />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BuildOnHat;
